"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceRegistrationService = void 0;
const axios_1 = require("@nestjs/axios");
const environment_1 = require("./environment");
class ServiceRegistrationService {
    constructor() {
        this.httpService = new axios_1.HttpService();
    }
    async registerService(service) {
        const serviceInfo = {
            name: `${service.name}`,
            url: `${service.url}`,
            port: `${service.port}`,
            healthCheck: '/health',
            status: service.status,
        };
        try {
            await this.httpService.post(`${environment_1.ENV.URL_SERVICE_REGISTRY}/service-registry/registry/register`, serviceInfo).toPromise();
            console.log('Service registered:', serviceInfo);
        }
        catch (error) {
            console.error('Failed to register service:', error);
        }
    }
    async unregisterService() {
        try {
            await this.httpService.delete(`${environment_1.ENV.URL_SERVICE_REGISTRY}/service-registry/registry/unregister/auth-service`).toPromise();
        }
        catch (error) {
            console.error('Failed to unregister service:', error);
        }
    }
}
exports.ServiceRegistrationService = ServiceRegistrationService;
